import React, { Component } from 'react';
import FlipMove from 'react-flip-move';
import { Waypoint } from 'react-waypoint';
import { connect } from 'react-redux';
import {fetchNews, fetchNewsItem} from '../redux/actions';
import { userSelector, newsSelector, chapterSelector, rankSelector } from '../redux/selectors'
import NewsItem from './NewsItem';
import NewsDetail from './NewsDetail';
import { toArray } from '../common/util';

class News extends Component {
    constructor(props) {
        super(props);
        this.handleUpdate= this.handleUpdate.bind(this);
    }
    componentDidMount() {
        document.title = "Addiction | News";
        if (this.props.match.params.id) {
            this.props.getNewsItem(this.props.match.params.id);
        }
    }
    handleUpdate() {
        if (!this.props.news.pending && this.props.news.more) {
            this.props.getNews(this.props.news.page);
        }
    }

    render() {
        const newsItems = toArray(this.props.news.data)
            .sort((a, b) => b.id - a.id)
            .map((news) => (
            <div key={`${news.id}-news`}>
                <NewsItem post={news} users={this.props.users} chapters={this.props.chapters} ranks={this.props.ranks} />
            </div>
        ));
        if (!this.props.match.params.id) {
            return (
                <div>
                    <h1>News</h1>
                    <FlipMove
                        staggerDelayBy={50}
                        appearAnimation="fade"
                        enterAnimation="fade"
                        leaveAnimation="fade"
                        className="news"
                    >
                        {newsItems}
                    </FlipMove>
                    <div>
                        <Waypoint
                            key="waypoint"
                            onEnter={this.handleUpdate}
                            bottomOffset='-10%'
                        />
                    </div>
                </div>
            )
        } else {
            const newsDetail = toArray(this.props.news.data)
                .filter(news => news.slug === this.props.match.params.id)
                .map((news) => (
                    <NewsDetail key={`${news.id}-newsdetail`} post={news} users={this.props.users} chapters={this.props.chapters} ranks={this.props.ranks}/>
                ));
            return <div>{newsDetail}</div>
        }
    }
}

// const filterNews = (news) => {
//     return news.sort((a, b) => (
//         new Date(b.created).getTime() - new Date(a.created).getTime()
//     ));
// };

const mapStateToProps = (state) => ({
    news: newsSelector(state),
    ranks: rankSelector(state),
    users: userSelector(state),
    chapters: chapterSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getNews: (page) => dispatch(fetchNews(page)),
    getNewsItem: (slug) => dispatch(fetchNewsItem(slug))
});

export default connect(mapStateToProps, mapDispatchToProps)(News);


// WEBPACK FOOTER //
// ./src/News/News.js